import PropTypes from "prop-types";
import { EyeSlashSolidV6 } from "@shared/v2/Icomoon";
import TextLink from "@shared/v2/TextLink";
import Typography from "@shared/v2/Typography";

const NoPermission = ({ title, body }) => (
  <div className="tw-flex-1 tw-flex tw-justify-center tw-items-center">
    <div className="tw-flex tw-flex-col tw-gap-[24px] tw-w-full tw-max-w-[448px]">
      <div className="tw-flex tw-justify-center">
        <EyeSlashSolidV6 size="xxl" />
      </div>
      <Typography variant="headline2" className="tw-text-center">
        {title}
      </Typography>
      <Typography variant="body-m" className="tw-text-center">
        {body}
      </Typography>
    </div>
  </div>
);

NoPermission.propTypes = {
  title: PropTypes.node,
  body: PropTypes.node,
};

NoPermission.defaultProps = {
  title: "You do not have permission to edit the roster",
  body: (
    <>
      Only admins on your team can view and edit the roster. If you need to edit your agent profile, visit the{" "}
      <TextLink href="/account">users page</TextLink>.
    </>
  ),
};

export default NoPermission;
